import { Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Helvetica',
  },
  table: {
    width: '100%',
    marginBottom: 20,
  },
  tableHeader: {
    backgroundColor: '#f3f4f6',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#e5e7eb',
    padding: 8,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderColor: '#e5e7eb',
    padding: 8,
    minHeight: 60,
  },
  criterionCol: { 
    width: '25%',
    paddingRight: 8,
  },
  levelCol: { 
    width: '22%',
    paddingRight: 8,
  },
  scoreCol: {
    width: '9%',
    paddingRight: 8,
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#111827', // text-gray-900
    wordBreak: 'normal',
    hyphens: 'none',
  },
  text: {
    fontSize: 7,
    color: '#4B5563', // text-gray-600
    wordBreak: 'normal',
    hyphens: 'none',
  },
  competencyText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#111827', // text-gray-900
    marginBottom: 4,
    wordBreak: 'normal',
    hyphens: 'none',
  },
  metadataText: {
    fontSize: 6,
    color: '#6B7280', // text-gray-500
    wordBreak: 'normal',
    hyphens: 'none',
  },
  scoreBox: {
    width: 30,
    height: 20,
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4, // rounded
    marginLeft: 'auto',
    marginRight: 'auto',
  }
});

const RubricPDF = ({ rubricData }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={[styles.headerText, styles.criterionCol]}>Criterion</Text>
          <Text style={[styles.headerText, styles.levelCol]}>Below Expectations{'\n'}(0-2)</Text>
          <Text style={[styles.headerText, styles.levelCol]}>Meets Expectations{'\n'}(2-4)</Text>
          <Text style={[styles.headerText, styles.levelCol]}>Exceeds Expectations{'\n'}(4-5)</Text>
          <Text style={[styles.headerText, styles.scoreCol]}>Score</Text>
        </View>
        
        {rubricData.rubrics.map((rubric, index) => (
          <View key={index} style={styles.tableRow}>
            <View style={styles.criterionCol}>
              <Text style={styles.competencyText}>{rubric.competency}</Text>

            </View>
            <Text style={[styles.text, styles.levelCol]}>
              {rubric.criteria.below_expectations.description}
            </Text>
            <Text style={[styles.text, styles.levelCol]}>
              {rubric.criteria.meets_expectations.description}
            </Text>
            <Text style={[styles.text, styles.levelCol]}>
              {rubric.criteria.exceeds_expectations.description}
            </Text>
            <View style={styles.scoreCol}>
              <View style={styles.scoreBox} />
            </View>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);

export default RubricPDF; 